/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isGuid, isObject } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";

const useDocuments = function () {
    
    const { token } = useAuth();
    
    const getDocument = async (guid) => {
        const document = await SimpliCityAdminSDK.document.findOne(token, guid);
        return document;
    };
    const archiveDocument = async (guid) => {
        const document = await SimpliCityAdminSDK.document.archive(token, guid);
        Logger.debug("archive document...");
        // const result = await SimpliCitySDK.document.archive(token, guid)
        // Logger.debug(`archive document result`, { result })
        // const { status, document } = result || {}
        Logger.debug(`archive document status ${status}`);
        return document;
    };
    const restoreDocument = async (guid) => {
        const result = await SimpliCityAdminSDK.document.restore(token, guid);
        Logger.debug("restore document...");
        Logger.debug("restore document result", { result });
        const { status, document } = result || {};
        Logger.debug(`archive document status ${status}`);
        return document;

    };
    const renameDocument = async (guid, renamed_file_name) => {
        const result = await SimpliCityAdminSDK.document.rename(token, guid, renamed_file_name);
        Logger.debug("rename document...");
        Logger.debug("rename document result", { result });
        // const status = result?.status;
        const document = result?.document;
        return document;
    };
    const deleteDocument = async (guid) => {
        const result = await SimpliCityAdminSDK.document.delete(token, guid);
        Logger.debug("delete document");
        Logger.debug("delete document result", { result });
        const status = result?.status;
        Logger.debug(`rename document status ${status}`);
        return { guid, status };
    };
    // const deleteArchiveDocument = async (guid) => {
    //     const document = await SimpliCityAdminSDK.document.deleteArchive(token, guid)
    //     Logger.debug('delete document')
    //     Logger.debug(`delete archive document result`, { document })
    //     return document
    // }
    const saveDocument = async (document) => {
        const { guid } = document || {};
        if (!isObject(document)) {
            throw Error("Document not provided to save");
        }
        if (!isGuid(guid)) {
            throw Error("Document did not hav a guid");
        }
        const updatedDocument = {
            guid: document?.guid,
            title: document?.title,
            description: document?.description,
            public: Boolean(document?.public).valueOf(),
            archived: Boolean(document?.archived).valueOf(),
            classification: document?.classification,
            sub_classification: document?.sub_classification,
            doc_id: document?.doc_id,
            external_id: document?.external_id,
            language: document?.language,
            owner: document?.owner,
            url: document?.url,
            audience: document?.audience ? document?.audience : undefined,
            retention_months: Number(document?.retention_months),
            isReplica: Boolean(document?.isReplica).valueOf(),
            type: document?.type
            // "file_name": "Bylaw_7458.pdf",
            // "file_ext": "pdf",
            // "file_type": "application/pdf",
            // "file_size": 937774,
            // "storage_account": "simplicityappdocuments",
            // "storage_container": "documents",
            // "storage_filepath": "Bylaw_7458.pdf",
            // "storage_url": "https://simplicityappdocuments.blob.core.windows.net/documents/Bylaw_7458.pdf",
            // "updated_at": "2023-09-12 04:14:02",
            // "updated_by": "f23e2470-e8d5-4718-acc2-7aed7726054c",
            // "created_at": "2023-09-09 06:53:25",
            // "created_by": "f23e2470-e8d5-4718-acc2-7aed7726054c"
        };
        
        if (guid) {
            const document_response = await SimpliCityAdminSDK.document.update(
                token, guid, updatedDocument
            );
            Logger.debug("save document result", { document_response });
            
        }
    };

    const getPlacements = async (guid) => {
        if (!guid) {
            return [];
        }
        const placements = await SimpliCityAdminSDK.document.placements(token, guid);
        // Logger.debug('document placements', placements)
        Logger.debug("document placements", { placements });
        return placements;
    };
    
    return {
        getDocument,
        saveDocument,
        archiveDocument,
        restoreDocument,
        renameDocument,
        deleteDocument,
        getPlacements,
        // restoreArchiveDocument,
        // deleteArchiveDocument
    };
};

export { useDocuments };
